<mc-dialog class="csv-modal" (closeEvent)="closeDialog()">
  <div class="feature-flag">
    <h2 class="feature-flag__title">Feature flag</h2>
    <ul class="feature-flag__list">
      @for (feature of featureFlagOptions; track feature.key) {
        <li class="feature-flag__item">
          <span class="feature-flag__item_name">{{ feature.name }}</span>
          <label class="custom-checkbox">
            <input
              type="checkbox"
              [checked]="feature.value"
              (change)="changeSelection(feature)"
              class="custom-checkbox__input"
              aria-label="feature selection checkbox"
            />
            <span class="custom-checkbox__icon"></span>
          </label>
        </li>
      }
    </ul>
  </div>
</mc-dialog>
